export const validEmail = email => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
export const validUKPostCode = postCode => /^(GIR 0AA)|((([ABCDEFGHIJKLMNOPRSTUWYZ][0-9][0-9]?)|(([ABCDEFGHIJKLMNOPRSTUWYZ][ABCDEFGHKLMNOPQRSTUVWXY][0-9][0-9]?)|(([ABCDEFGHIJKLMNOPRSTUWYZ][0-9][ABCDEFGHJKSTUW])|([ABCDEFGHIJKLMNOPRSTUWYZ][ABCDEFGHKLMNOPQRSTUVWXY][0-9][ABEHMNPRVWXY])))) [0-9][ABDEFGHJLNPQRSTUWXYZ]{2})$/i.test(postCode);
export const notNullOrEmpty = text => !!text && text.length > 0;
export const validUKPhoneNumber = number => /^(?:0|\+?44?[ ])(?:\d\s?){9,10}$/i.test(number);
export const isNumber = number => /^\d+$/i.test(number);
export const isValidTime = time => /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(time);
export const validTown = town => notNullOrEmpty(town) && /^[A-Za-z\s\-']{2,50}$/i.test(town);

export const validateField = (isValidFn, exp, setValidationErrorsFn) => {

    const fieldIsValid = !!isValidFn();
    const fieldName = exp.toString();

    if (!fieldIsValid) {
        setValidationErrorsFn(current => {
            if (!current || !Object.hasOwn(current, fieldName)) {
                current ??= {};
                current[fieldName] = false;
            }
            return current;
        });

    }
    else {
        setValidationErrorsFn(current => {
            if (current && Object.hasOwn(current, fieldName)) {
                delete current[fieldName];
            }
            return current;
        });
    }
};